import { EapSettingsTlsFormValidationModel } from './eap-settings-form-tls-protocol.model';

export const initialEapTlsFormValidation: EapSettingsTlsFormValidationModel = {
    username: { state: 'valid' },
    clientCertificateFilename: { state: 'valid' },
    clientPrivateKeyFilename: { state: 'valid' },
    password: { state: 'valid' },
    confirmPassword: { state: 'valid' },
};
